import React from 'react';
import { faBullhorn, faWaveSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cva, type VariantProps } from 'class-variance-authority';

const iconVariants = cva(
  'flex items-center justify-center',
  {
    variants: {
      variant: {
        amplify: 'bg-lime-5',
        pulse: 'bg-blue-5'
      },
      size: {
        sm: 'min-w-[32px] min-h-[32px] p-1.5',
        md: 'min-w-[48px] min-h-[48px] p-2',
        lg: 'min-w-[64px] min-h-[64px] p-3',
      },
      rounded: {
        none: 'rounded-none',
        sm: 'rounded-sm',
        md: 'rounded-md',
        lg: 'rounded-lg',
        xl: 'rounded-xl',
        full: 'rounded-full'
      }
    },
    defaultVariants: {
      size: 'md',
      rounded: 'xl'
    }
  }
);

interface IconProps extends VariantProps<typeof iconVariants> {
  className?: string;
}

export const AmplifyIcon = ({ size, rounded, className }: IconProps) => (
  <div className={iconVariants({ variant: 'amplify', size, rounded, className })}>
    <FontAwesomeIcon
      icon={faBullhorn}
      className="text-white"
      fontSize={size === 'sm' ? 14 : size === 'lg' ? 28 : 20}
    />
  </div>
);

export const PulseIcon = ({ size, rounded, className }: IconProps) => (
  <div className={iconVariants({ variant: 'pulse', size, rounded, className })}>
    <FontAwesomeIcon
      icon={faWaveSquare}
      className="text-white"
      fontSize={size === 'sm' ? 14 : size === 'lg' ? 28 : 20}
    />
  </div>
);
